/**
 * Прогрев ленивых синглтонов на DOMContentLoaded (capture), чтобы темы,
 * обращающиеся к window.Shop / Cart / … в том же тике после события,
 * получали уже созданные инстансы. Порядок: Shop до FavoritesProducts.
 */
import perfDebug from '@/helpers/perfDebug';

function warmupDeferredGlobals() {
  perfDebug.timeSync('warmupDeferredGlobals', function() {
    void window.Shop;
    void window.InsalesCommonCart;
    void window.Cart;
    void window.Compare;
    void window.FavoritesProducts;
    void window.Products;
    void window.AjaxSearch;
    void window.Template;
    void window.EventBus;
  });
}

document.addEventListener('DOMContentLoaded', warmupDeferredGlobals, { capture: true });
